var _rect, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "37.2 9.89 7.67 9.77 18.88 21.82 37.2 9.89",
    fill: "none"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.78 25.35 24.38 39.07 39.59 13.11 20.78 25.35",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.68,6.93c-.35-.62-1.01-1.01-1.73-1.01l-41.89-.16h0c-.79,0-1.51,.47-1.83,1.2-.32,.73-.18,1.58,.37,2.17l14.78,15.88c.05,.23,.14,.46,.27,.67,.04,.06,.09,.1,.13,.15l4.97,18.94c.21,.78,.86,1.36,1.66,1.47,.09,.01,.18,.02,.27,.02,.7,0,1.36-.37,1.73-.99L46.67,8.93c.36-.62,.37-1.38,0-2Zm-9.48,2.96l-18.32,11.93L7.67,9.77l29.53,.12Zm-12.82,29.18l-3.6-13.73,18.81-12.24-15.21,25.97Z",
    fill: outlineColor
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSend);
export default __webpack_public_path__ + "static/media/ico-send.9b2234d68247c08b247701432181a2b5.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;